
import React, { useEffect, useRef, useState } from "react";
import { FiBell, FiBellOff, FiInfo, FiMessageSquare, FiPrinter } from "react-icons/fi";
import { FaTrashAlt } from "react-icons/fa";
import { CiMenuKebab } from "react-icons/ci";
import { formatTime } from "../../APIHelpers/utils";
import dayjs from "dayjs";
import { FaPaperPlane, FaPencil, FaXmark } from "react-icons/fa6";
import { LuBan, LuClock, LuSquareArrowOutUpRight, LuTicketSlash } from "react-icons/lu";
import {
  Card,
  Form,
  Button,
  Stack,
  Image,
  InputGroup,
  FormGroup,
  Badge,
  Collapse,
  ListGroup,
} from "react-bootstrap";
import {
  ChatSocket,
  roomIdOf,
} from "../../APIServices/GoServerApi/chatService";
import { inboxServices } from "../../APIServices/SitePilotManagement/inboxServices";
import { useApp } from "../../APIHelpers/AppContext";
import { CgSmileMouthOpen } from "react-icons/cg";
import { GoLink } from "react-icons/go";
import Picker from "@emoji-mart/react";
import { Data } from "emoji-mart";
import { userServices } from "../../APIServices/UserData/userServices";
import Swal from "sweetalert2";
import ViewSessionList from "./ViewSessionList";
import UseToggle from "../../Hooks/UseToggle";
import { RxLapTimer } from "react-icons/rx";
import AssignAgentList from "./AssignAgentList";
import SessionInformation from "./SessionInformation";

const InboxChats = ({
  isExpanded,
  setExpandedId,
  inboxData,
  currentUserData,
  getSingleInbox,
  type,
  setMessages,
  messages,
  setSessionId,
  sessionId,
  deleteSession,
  setOpenHistory,
  category
}) => {
  const wsRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [hideNotification, setHideNotification] = useState(true);
  const [inputMsg, setInputMsg] = useState("");
  const [clientDraft, setClientDraft] = useState("");
  const [assignedUser, setAssignedUser] = useState("");
  const [members, setMembers] = useState([]);
  const messagesEndRef = useRef(null);
  const [showEmoji, setShowEmoji] = useState(false);
  const inputRef = useRef(null);
  const toggles = UseToggle();

  const { handleChatClick, openChat, chatList } = useApp();

  const propertyId = currentUserData?.loginPropertyId || "";

  const updateInboxSession = async (type, value) => {
    Swal.fire({
      title: "Are you sure?",
      text: type !== "assigned" ? `Do you want to ${value} ${type}?` : `Do you want to ${value === currentUserData?.userId ? "Join this Conversation" : "Assign this Agent"}?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: type !== "assigned" ? `Yes, ${value} ${type} it!` : `Yes, ${value === currentUserData?.userId ? "Join" : "Assign"} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.inboxId = inboxData?.inboxId;
        userData.sessionId = inboxData?.sessionId;
        if (type === "chat") {
          userData.chatStatusType = true;
          userData.chatStatus = value;
        } else if (type === "session") {
          userData.sessionStatusType = true;
          userData.sessionStatus = value;
        } else if (type === "assigned") {
          userData.assignedUserType = true;
          userData.propertyId = propertyId;
          userData.assignedUser = value;
        }
        let data = await inboxServices.updateInboxSession(userData);
        if (data?.statusCode === 200) {
          getSingleInbox(inboxData?.inboxId, inboxData?.sessionId);
        }
      }
    });
  };

  const getMembers = async () => {
    let data = await userServices.getMembers("active");
    setMembers(data?.data || []);
  };

  useEffect(() => {
    setInputMsg("");
    if (!inboxData?.assignedUser) {
      getMembers();
    }
    setHideNotification(true);
  }, [propertyId]);

  useEffect(() => {
    setAssignedUser(inboxData?.assignedUser || currentUserData?.userId);
  }, [currentUserData, inboxData]);

  const [scrollTarget, setScrollTarget] = useState(null);

  const dateRefs = useRef({});

  useEffect(() => {
    if (!scrollTarget || scrollTarget.type === "bottom") {
      messagesEndRef.current?.scrollIntoView({
        behavior: "smooth",
      });
    }

    if (scrollTarget?.type === "date") {
      const el = dateRefs.current[scrollTarget.label];

      el?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [messages, clientDraft, scrollTarget]);

  const emitTypingPreview = (text) => {
    const inboxId = inboxData?.inboxId;
    const sessionId = inboxData?.sessionId;
    if (!propertyId || !inboxId || !sessionId || !wsRef.current) return;

    wsRef.current.sendRoomTyping({
      propertyId,
      visitorId: inboxId,
      sessionId: sessionId,
      text: text ?? "",
      type: "message",
      userType: "agent",
      userId: inboxData?.assignedUser,
      userIcon: inboxData?.agentIcon,
      userName: inboxData?.agentName,
    });
  };

  useEffect(() => {
    if (!propertyId || !inboxData) return;

    const inboxId = inboxData?.inboxId;
    const sessionId = inboxData?.sessionId;
    const roomId = roomIdOf(propertyId, inboxId, sessionId);

    const socket = new ChatSocket({
      userId: "admin",
      name: "Admin",
      onOpen: () => socket.joinRoom({ propertyId, visitorId: inboxId, sessionId }),
      onEvent: (type, data) => {
        if (type === "message:new" && data?.convId === roomId) {
          setClientDraft("");
          emitTypingPreview("");
          setMessages((prev) => [
            ...prev,
            {
              messageId: data.id,
              userType: data.userType,
              message: data.text || "",
              pageName: data.pageName || "",
              pageURL: data.pageURL || "",
              type: data.type,
              userIcon: data?.userIcon,
              userId: data?.userId,
              userName: data?.userName,
              createdAt: data.ts || Date.now(),
            },
          ]);
          return;
        }

        if (type === "room:typing" && data?.convId === roomId) {
          const senderId = String(data?.from || "").trim();
          const senderType = String(data?.userType || "").trim().toLowerCase();
          const currentAdminId = "admin";

          const isSelfTyping = senderId === currentAdminId;
          const isVisitorTyping = senderType === "visitor";

          if (!isSelfTyping && isVisitorTyping) {
            setClientDraft(data?.text ? data : "");
          } else {
            setClientDraft("");
          }
        }
      },
    });

    socket.connect();
    wsRef.current = socket;

    return () => {
      socket.disconnect?.();
      wsRef.current = null;
    };
  }, [propertyId, inboxData, currentUserData]);

  const sendMessage = async (inboxId) => {
    const text = String(inputMsg || "").trim();
    if (!text || !wsRef.current) return;

    const ok = wsRef.current.sendRoomMessage({
      propertyId,
      visitorId: inboxId,
      sessionId: inboxData?.sessionId,
      userId: inboxData?.assignedUser,
      userIcon: inboxData?.agentIcon,
      userName: inboxData?.agentName,
      text,
      userType: "agent",
      type: "message",
    });

    if (ok) {
      const res = await inboxServices.sendInboxMessage({
        inboxId,
        sessionId: inboxData?.sessionId,
        userId: inboxData?.assignedUser,
        userIcon: inboxData?.agentIcon,
        userName: inboxData?.agentName,
        type: "message",
        message: text,
        userType: "agent",
      });

      if (res?.statusCode === 200) {
        setInputMsg("");
      }
    }
  };

  const getChatDateLabel = (date) => {
    const msgDate = dayjs(date);
    const today = dayjs();
    if (msgDate.isSame(today, "day")) {
      return "Today";
    }
    if (msgDate.isSame(today.subtract(1, "day"), "day")) {
      return "Yesterday";
    }
    if (msgDate.isSame(today, "week")) {
      return msgDate.format("dddd");
    }
    return msgDate.format("dddd, DD MMM YYYY");
  };

  useEffect(() => {
    const close = () => setShowEmoji(false);
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);

  let checkOpenMiniChat = chatList?.some(
    (item) => item.inboxId === inboxData?.inboxId && item.sessionId === inboxData?.sessionId
  );

  return (
    <>
      <Card className={`${type === "miniChat" && "border-0 rounded-0"} h-100 w-100`}>
        {type === "miniChat" && (
          <Card.Header className="p-2">
            <Stack direction="horizontal" className="justify-content-between">
              <div className="hstack gap-2">
                <Badge
                  pill
                  bg="transparent"
                  className={`tag-pill text-capitalize text-${inboxData.sessionStatus === "open" ? "danger" : "success"}`}
                  style={{
                    fontSize: "10px",
                    border: `1px solid var(--${inboxData.sessionStatus === "open" ? "danger" : "success"})`,
                  }}
                >
                  Session {inboxData?.sessionStatus}
                </Badge>
                <Badge
                  pill
                  bg="transparent"
                  className={`tag-pill text-capitalize text-${inboxData.chatStatus === "browsing" ? "warning" : inboxData.chatStatus === "open" ? "danger" : "success"}`}
                  style={{
                    fontSize: "10px",
                    border: `1px solid var(--${inboxData.chatStatus === "browsing" ? "warning" : inboxData.chatStatus === "open" ? "danger" : "success"})`,
                  }}
                >
                  Chat {inboxData?.chatStatus}
                </Badge>
              </div>
              <Stack direction="horizontal" gap={2} className="position-relative">
                <FiPrinter style={{ fontSize: 12 }} className="CP" title="Print" />
                <RxLapTimer style={{ fontSize: 12 }} className="CP" title="View Session" onClick={toggles.setToggle} />
                {isExpanded && (
                  <>
                    <FaXmark style={{ fontSize: 12 }} className="CP" onClick={() => setExpandedId("")} />
                    <FaTrashAlt style={{ fontSize: 12 }} className="CP" />
                  </>
                )}
                <CiMenuKebab className="CP" title="Open Menu" onClick={() => setOpenMenu((prev) => !prev)} />
                <Collapse in={openMenu}>
                  <div
                    style={{
                      position: "absolute",
                      right: -8,
                      top: 24,
                      zIndex: 1000,
                      fontSize: 12,
                    }}
                  >
                    <ListGroup>
                      {inboxData?.sessionStatus === "open" && (
                        <ListGroup.Item
                          action
                          className="hstack gap-2 text-nowrap"
                          onClick={() => updateInboxSession("session", "closed")}
                        >
                          <LuClock /> Close Session
                        </ListGroup.Item>
                      )}
                      {inboxData?.sessionStatus === "open" && inboxData?.chatStatus !== "closed" && (
                        <ListGroup.Item
                          action
                          className="hstack gap-2 text-nowrap"
                          onClick={() => updateInboxSession("chat", "closed")}
                        >
                          <FiMessageSquare /> Close Chat
                        </ListGroup.Item>
                      )}
                      <ListGroup.Item action className="hstack gap-2 text-nowrap">
                        <LuBan /> Engaged Agents
                      </ListGroup.Item>
                      <ListGroup.Item
                        action
                        className="hstack gap-2 text-nowrap"
                        onClick={() => setHideNotification(!hideNotification)}
                      >
                        {hideNotification ? <FiBellOff /> : <FiBell />} {hideNotification ? "Hide" : "Show"} Notification
                      </ListGroup.Item>
                      <ListGroup.Item action className="hstack gap-2 text-nowrap">
                        <FiInfo /> Session Info
                      </ListGroup.Item>
                    </ListGroup>
                  </div>
                </Collapse>
              </Stack>
            </Stack>
          </Card.Header>
        )}

        {type !== "miniChat" && (
          <Card.Header>
            <Stack direction="horizontal" className="justify-content-between">
              <Stack direction="horizontal" gap={2}>
                <Image src={inboxData?.icon} roundedCircle width={35} height={35} />
                {inboxData?.type === "inbox" ? (
                  <div>
                    <div className="fw-semibold">{inboxData?.name}</div>
                    <small className="text-muted">{inboxData?.email}</small>
                  </div>
                ) : (
                  <div>
                    <div className="fw-semibold">{inboxData?.inboxId}</div>
                  </div>
                )}
              </Stack>
              <Stack direction="horizontal" gap={2}>
                {type !== "quickChat" && (
                  <>
                    <div className="py-1">
                      <Badge
                        pill
                        bg="transparent"
                        className={`tag-pill text-capitalize text-${inboxData.sessionStatus === "open" ? "danger" : "success"}`}
                        style={{
                          fontSize: "10px",
                          border: `1px solid var(--${inboxData.sessionStatus === "open" ? "danger" : "success"})`,
                        }}
                      >
                        Session {inboxData?.sessionStatus}
                      </Badge>
                    </div>
                    <div className="py-1">
                      <Badge
                        pill
                        bg="transparent"
                        className={`tag-pill text-capitalize text-${inboxData.chatStatus === "browsing" ? "warning" : inboxData.chatStatus === "open" ? "danger" : "success"}`}
                        style={{
                          fontSize: "10px",
                          border: `1px solid var(--${inboxData.chatStatus === "browsing" ? "warning" : inboxData.chatStatus === "open" ? "danger" : "success"})`,
                        }}
                      >
                        Chat {inboxData?.chatStatus}
                      </Badge>
                    </div>
                  </>
                )}
                <Button size="sm" variant="light" title="Print">
                  <FiPrinter />
                </Button>
                {category === "inbox" && type !== "quickChat" && (
                  <Button size="sm" variant="light" title="View Session" onClick={toggles.setToggle}>
                    <RxLapTimer />
                  </Button>
                )}
                {!checkOpenMiniChat && (
                  <Button onClick={() => handleChatClick(inboxData)} size="sm" variant="light">
                    <LuSquareArrowOutUpRight />
                  </Button>
                )}
                {type === "quickChat" && (
                  <Button className="text-danger" size="sm" variant="light" title="Hide Session" onClick={() => setExpandedId("")}>
                    <FaXmark />
                  </Button>
                )}
                <Button size="sm" variant="light" title="Open Menu" onClick={() => setOpenMenu((prev) => !prev)}>
                  <CiMenuKebab />
                </Button>

                <Collapse in={openMenu}>
                  <div
                    style={{
                      position: "absolute",
                      right: 0,
                      top: 52,
                      zIndex: 1000,
                      fontSize: 12,
                    }}
                  >
                    <ListGroup>
                      {!(inboxData?.chatStatus === "closed" || inboxData?.sessionStatus === "closed") && inboxData?.type === "inbox" && (
                        <ListGroup.Item
                          action
                          className="hstack gap-2 text-nowrap"
                          onClick={() => setOpenHistory("Ticket")}
                        >
                          <LuTicketSlash /> Create Ticket
                        </ListGroup.Item>
                      )}
                      {inboxData?.sessionStatus === "open" && (
                        <ListGroup.Item
                          action
                          className="hstack gap-2 text-nowrap"
                          onClick={() => updateInboxSession("session", "closed")}
                        >
                          <LuClock /> Close Session
                        </ListGroup.Item>
                      )}
                      {inboxData?.sessionStatus === "open" && inboxData?.chatStatus !== "closed" && (
                        <ListGroup.Item
                          action
                          className="hstack gap-2 text-nowrap"
                          onClick={() => updateInboxSession("chat", "closed")}
                        >
                          <FiMessageSquare /> Close Chat
                        </ListGroup.Item>
                      )}
                      {inboxData?.assignedUser && (
                        <ListGroup.Item
                          action
                          className="hstack gap-2 text-nowrap"
                          onClick={toggles.setToggle1}
                        >
                          <LuBan /> Engaged Agents
                        </ListGroup.Item>
                      )}
                      <ListGroup.Item
                        action
                        className="hstack gap-2 text-nowrap"
                        onClick={() => setHideNotification(!hideNotification)}
                      >
                        {hideNotification ? <FiBellOff /> : <FiBell />} {hideNotification ? "Hide" : "Show"} Notification
                      </ListGroup.Item>
                      <ListGroup.Item
                        action
                        onClick={deleteSession}
                        className="hstack gap-2 text-nowrap"
                      >
                        <FaTrashAlt /> Delete
                      </ListGroup.Item>
                      <ListGroup.Item
                        action
                        className="hstack gap-2 text-nowrap"
                        onClick={toggles.setToggle2}
                      >
                        <FiInfo /> Session Info
                      </ListGroup.Item>
                    </ListGroup>
                  </div>
                </Collapse>
              </Stack>
            </Stack>
          </Card.Header>
        )}

        <Card.Body
          className="overflow-auto"
          style={{
            height:
              type === "miniChat"
                ? "300px"
                : `calc(100vh - ${inboxData?.type === "inbox" ? "322" : "272"}px)`,
          }}
        >
          {messages?.map((msg, i) => {
            const isAgent = msg.userType === "agent";

            const currentLabel = getChatDateLabel(msg.createdAt);
            const prevLabel =
              i > 0 ? getChatDateLabel(messages[i - 1].createdAt) : null;

            const showDateDivider = i === 0 || currentLabel !== prevLabel;

            return (
              <React.Fragment key={msg.messageId || i}>
                {showDateDivider && (
                  <div
                    onClick={() =>
                      setScrollTarget({
                        type: "date",
                        label: currentLabel,
                      })
                    }
                    className={`text-center ${i === 0 ? "mb-3" : (i + 1) === messages?.length ? "mt-3" : "my-3"}`}
                  >
                    <span
                      className="px-3 py-1 rounded bg-light text-muted"
                      style={{ fontSize: 12 }}
                    >
                      {currentLabel}
                    </span>
                  </div>
                )}
                <Stack
                  direction="horizontal"
                  className={`${(hideNotification || msg.type === "message") && "mb-4"} ${msg.type === "message"
                    ? isAgent
                      ? "justify-content-end align-items-end"
                      : "justify-content-start align-items-end"
                    : "justify-content-center w-100"
                    }`}
                  gap={2}
                >
                  {!isAgent && msg.type === "message" && (
                    <Image
                      src={msg?.userIcon}
                      alt={msg?.userName}
                      roundedCircle
                      width={25}
                      height={25}
                    />
                  )}

                  {msg.type === "message" ? (
                    <div style={{ maxWidth: 540, fontSize: 14 }}>
                      <div className={`${isAgent && "text-end"} d-block`}>
                        <Form.Text>{msg.userName}</Form.Text>
                      </div>

                      <div className="px-3 py-1 rounded bg-light text-dark">
                        {msg.message.split("\n").map((l, i) => (
                          <div key={i}>{l}</div>
                        ))}

                        <div
                          className={`small mt-1 ${isAgent ? "text-end" : "text-start"}`}
                          style={{ fontSize: 10 }}
                        >
                          {formatTime(msg.createdAt)}
                        </div>
                      </div>
                    </div>
                  ) : (
                    hideNotification && (
                      <div className="d-flex gap-2 w-100">
                        <FiBell className="mt-2" />

                        <div
                          className="p-2 gap-2 bg-light rounded w-100 d-flex justify-content-between align-items-end"
                          style={{
                            fontSize: 12,
                            borderLeft: "3px solid #0d6efd",
                          }}
                        >
                          {msg.type === "navigate" ? (
                            <span>
                              Visitor has Navigated to the{" "}
                              <a href={msg.pageURL} target="__blank" rel="noreferrer">
                                {msg.pageName}
                              </a>{" "}
                              page.
                            </span>
                          ) : (
                            <span>{msg.message}</span>
                          )}

                          <span
                            className="text-nowrap"
                            style={{
                              fontSize: 11,
                              color: "#6c757d",
                            }}
                          >
                            {formatTime(msg.createdAt)}
                          </span>
                        </div>
                      </div>
                    )
                  )}

                  {isAgent && msg.type === "message" && (
                    <Image
                      src={msg?.userIcon}
                      alt={msg?.userName}
                      roundedCircle
                      width={25}
                      height={25}
                    />
                  )}
                </Stack>
              </React.Fragment>
            );
          })}

          {clientDraft && (
            <Stack
              direction="horizontal"
              className="mb-1 align-items-end justify-content-start"
              gap={2}
            >
              <Image
                src={clientDraft?.userIcon}
                alt={clientDraft?.userName}
                roundedCircle
                width={25}
                height={25}
              />
              <div
                className="px-3 py-1 rounded hstack"
                style={{
                  maxWidth: 540,
                  fontSize: 14,
                  background: "#f2fad1",
                  color: "#111827",
                }}
              >
                <span>{clientDraft.text}...</span>
                <span className="hstack typing-icon">
                  <FaPencil />
                </span>
              </div>
            </Stack>
          )}
          <div ref={messagesEndRef} />
        </Card.Body>

        {inboxData?.assignedUser === currentUserData?.userId ? (
          <>
            {inboxData?.chatStatus === "closed" || inboxData?.sessionStatus === "closed" ? (
              <>
                {type === "miniChat" ? (
                  <Card.Footer style={{ height: "auto" }} className="hstack justify-content-center p-0">
                    <Button
                      className="text-nowrap w-100 rounded-0"
                      variant="primary"
                      disabled
                      style={{ fontSize: 13 }}
                    >
                      Session Closed
                    </Button>
                  </Card.Footer>
                ) : (
                  <Card.Footer style={{ height: 88 }} className="hstack justify-content-center">
                    <Button
                      className="text-nowrap w-25"
                      variant="primary"
                      onClick={() => setOpenHistory("Ticket")}
                      style={{ fontSize: 13 }}
                    >
                      Create New Ticket
                    </Button>
                  </Card.Footer>
                )}
              </>
            ) : (
              <>
                {type === "miniChat" ? (
                  <Card.Footer className="p-0">
                    <FormGroup className="position-relative">
                      <InputGroup>
                        <Form.Control
                          ref={inputRef}
                          as="textarea"
                          rows={1}
                          placeholder="Reply..."
                          className="border-0 rounded-0"
                          value={inputMsg}
                          onChange={(e) => {
                            emitTypingPreview(e.target.value);
                            setInputMsg(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                              e.preventDefault();
                              sendMessage(inboxData?.inboxId);
                            }
                          }}
                        />

                        <Button
                          size="sm"
                          variant="light"
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowEmoji((prev) => !prev);
                          }}
                        >
                          <CgSmileMouthOpen />
                        </Button>

                        <Button size="sm" variant="light">
                          <GoLink />
                        </Button>

                        <Button
                          size="sm"
                          variant="light"
                          onClick={() => sendMessage(inboxData?.inboxId)}
                        >
                          <FaPaperPlane />
                        </Button>
                      </InputGroup>

                      {showEmoji && (
                        <div
                          style={{
                            position: "absolute",
                            bottom: "35px",
                            zIndex: 9999,
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Picker
                            data={Data}
                            theme="light"
                            onEmojiSelect={(emoji) => {
                              setInputMsg((prev) => prev + emoji.native);
                              inputRef.current?.focus();
                            }}
                          />
                        </div>
                      )}
                    </FormGroup>
                  </Card.Footer>
                ) : (
                  <Card.Footer>
                    <FormGroup className="position-relative">
                      <Stack direction="horizontal" gap={2} className="align-items-end">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Reply..."
                          value={inputMsg}
                          onChange={(e) => {
                            emitTypingPreview(e.target.value);
                            setInputMsg(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                              e.preventDefault();
                              sendMessage(inboxData?.inboxId);
                            }
                          }}
                        />
                        <div>
                          <div className="mb-1">
                            <Button
                              size="sm"
                              variant="light"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowEmoji((prev) => !prev);
                              }}
                            >
                              <CgSmileMouthOpen />
                            </Button>

                            <Button size="sm" variant="light">
                              <GoLink />
                            </Button>
                          </div>
                          <Button
                            size="sm"
                            variant="primary"
                            className="d-flex gap-2"
                            onClick={() => sendMessage(inboxData?.inboxId)}
                          >
                            <FaPaperPlane className="mt-1" /> Send
                          </Button>
                        </div>
                      </Stack>
                      {showEmoji && (
                        <div
                          style={{
                            position: "absolute",
                            bottom: 82,
                            right: -16,
                            zIndex: 9999,
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Picker
                            data={Data}
                            theme="light"
                            onEmojiSelect={(emoji) => {
                              setInputMsg((prev) => prev + emoji.native);
                              inputRef.current?.focus();
                            }}
                          />
                        </div>
                      )}
                    </FormGroup>
                  </Card.Footer>
                )}
              </>
            )}
          </>
        ) : (
          <>
            {inboxData?.chatStatus === "closed" || inboxData?.sessionStatus === "closed" ? (
              <>
                {type === "miniChat" ? (
                  <Card.Footer style={{ height: "auto" }} className="hstack justify-content-center p-0">
                    <Button
                      className="text-nowrap w-100 rounded-0"
                      variant="primary"
                      style={{ fontSize: 13 }}
                    >
                      Session Closed
                    </Button>
                  </Card.Footer>
                ) : (
                  <Card.Footer style={{ height: 88 }} className="hstack justify-content-center">
                    <Button
                      className="text-nowrap w-25"
                      variant="primary"
                      onClick={() => setOpenHistory("Ticket")}
                      style={{ fontSize: 13 }}
                    >
                      Create New Ticket
                    </Button>
                  </Card.Footer>
                )}
              </>
            ) : (
              <Card.Footer style={{ height: type === "miniChat" ? "auto" : 88 }} className={`hstack justify-content-center ${type === "miniChat" && "p-0"}`}>
                <InputGroup className={`${type === "miniChat" ? "w-100" : "w-75"} m-auto`}>
                  {currentUserData?.roleType === "organization" && (
                    <Form.Select
                      className={`${type === "miniChat" && "rounded-0"} m-50`}
                      onChange={(e) => setAssignedUser(e.target.value)}
                      value={assignedUser}
                    >
                      <option value={currentUserData?.userId}>You</option>
                      {members?.map((item, index) => (
                        <option key={index} value={item?.userId}>
                          {item?.name}
                        </option>
                      ))}
                    </Form.Select>
                  )}
                  <Button
                    className={`text-nowrap ${type === "miniChat" && "rounded-0"} ${currentUserData?.roleType === "organization"
                      ? type === "miniChat"
                        ? "w-50"
                        : "w-25"
                      : type === "miniChat"
                        ? "w-100"
                        : "w-25"
                      } m-auto`}
                    variant="primary"
                    style={{ fontSize: 13 }}
                    onClick={() => updateInboxSession("assigned", assignedUser)}
                  >
                    {assignedUser === currentUserData?.userId ? "Join Conversation" : "Assign Agent"}
                  </Button>
                </InputGroup>
              </Card.Footer>
            )}
          </>
        )}
      </Card>

      <ViewSessionList
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`View Session List`}
        inboxId={inboxData?.inboxId}
        setSessionId={setSessionId}
        sessionId={sessionId}
        openChat={openChat}
        handleChatClick={handleChatClick}
      />
      <AssignAgentList
        show={!toggles.toggle1}
        hide={() => toggles.setToggle1()}
        title={`Engaged Agents`}
        messages={inboxData?.messages}
      />
      <SessionInformation
        show={!toggles.toggle2}
        hide={() => toggles.setToggle2()}
        title={`Session Information`}
        inboxData={inboxData}
      />
    </>
  );
};

export default InboxChats;
